import { serviceWrapper } from './configs';

export default new (class HrVenueService {
  constructor() {
    this.service = {
      root: 'Company',
    };
  }

  async Post(url, params, service = this.service) {
    try {
      const { data: { body } } = await serviceWrapper(
        service,
        { path: url, type: 'post' },
        params,
      );

      return body;
    } catch (error) {
      return error.response.data;
    }
  }

  async Patch(url, params, service = this.service) {
    try {
      const { data: { body } } = await serviceWrapper(
        service,
        { path: url, type: 'patch' },
        params,
      );

      return body;
    } catch (error) {
      return error.response.data;
    }
  }

  async Put(url, params, service = this.service) {
    try {
      const { data: { body } } = await serviceWrapper(
        service,
        { path: url, type: 'put' },
        params,
      );
      return body;
    } catch (err) {
      return err.response.data;
    }
  }

  async Delete(url, params, service = this.service) {
    try {
      const { data: { body } } = await serviceWrapper(
        service,
        { path: url, type: 'delete' },
        params,
      );
      return body;
    } catch (err) {
      return err.response.data;
    }
  }

  async Get(url, service = this.service) {
    try {
      const { data: { body } } = await serviceWrapper(
        service,
        { path: url, type: 'get' },
        {},
      );
      return body;
    } catch (err) {
      return err.response.data;
    }
  }

  async healthCheck() {
    const response = await this.Get('Check');
    return response;
  }

  async getCreditRight() {
    // candidate ekledikten sonra, send butona tıklandığında çıkacak popup kontrolü
    const response = await this.Get('', { root: 'CompanyRight/async-interview-right' });
    return response;
  }

  async getSendableCount() {
    const response = await this.Get('', { root: 'CompanyRight/sendable-count' });
    return response;
  }

  async getInterview(interviewId) {
    const response = await this.Get(`${interviewId}`, { root: 'Interview' });
    return response;
  }

  async getUsers() {
    const requestObject = {
      searchText: '',
      pageIndex: 1,
      pageSize: 1000,
    };
    const response = await this.Post('list', requestObject, {
      root: 'User',
    });
    return response;
  }

  async updateUser({
    name, surname, email, id, userRoleId,
  }) {
    const requestObject = {
      name,
      surname,
      email,
      userRoleId,
    };
    const response = await this.Post(`${id}`, requestObject, {
      root: 'User',
    });
    return response;
  }

  async saveUser({ name, surname, email }) {
    const requestObject = {
      name,
      surname,
      mail: email,
      userRole: 2,
    };
    const response = await this.Post('', requestObject, {
      root: 'User',
    });
    return response;
  }

  async deleteUser(id) {
    const requestObject = {
      id,
    };
    const response = await this.Delete(`${id}/`, requestObject, {
      root: 'User',
    });
    return response;
  }

  async getInterviews(isActive, pageIndex, pageSize, types, searchText, isListPage, sortBy, order) {
    // InterviewSortByType {
    //   None = 0,
    //   Title = 1,
    //   LastModifyDate = 2,
    //   CreationDate = 3,
    //   TotalCount = 4,
    //   CompletedCount = 5,
    //   NotCompletedCount = 6,
    //  }
    // OrderType {
    //   None = 0,
    //   Asc = 1,
    //   Desc = 2,
    // }
    const requestObject = {
      isActive,
      pageIndex,
      pageSize,
      types,
      searchText,
      isListPage,
      sortBy,
      order,
    };

    const response = await this.Post('list', requestObject, {
      root: 'Interview',
    });
    return response;
  }

  async changeInterviewStatus(interviewId, candidateId, interviewStatus) {
    const requestObject = {
      interviewId,
      candidateId,
      interviewStatus,
    };

    const response = await this.Post(
      'Interview/ChangeInterviewStatus',
      requestObject,
    );
    return response;
  }

  async updateInterview(
    interviewId,
    name,
    description,
    expireDate,
    isQuestionsChange,
    isActive,
    questions,
    isSent,
    type,
    visibilityType,
    authorizedUserIds,
    positionId,
    languageId,
    questionLanguageId,
    jobDescription,
  ) {
    const requestObject = {
      id: interviewId,
      name,
      description,
      expireDate,
      isActive,
      questions,
      isSent,
      isQuestionsChange,
      type,
      visibilityType,
      authorizedUserIds,
      positionId,
      languageId,
      questionLanguageId,
      jobDescription,
    };

    const response = await this.Put('', requestObject, { root: 'Interview' });
    return response;
  }

  async createInterview(
    name,
    description,
    expireDate,
    questions,
    type,
    visibilityType,
    authorizedUserIds,
    positionId,
    languageId,
    questionLanguageId,
    jobDescription,
  ) {
    const requestObject = {
      name,
      description,
      questions,
      type,
      visibilityType,
      authorizedUserIds,
      positionId,
      languageId,
      questionLanguageId,
      jobDescription,
    };

    const response = await this.Post('', requestObject, { root: 'Interview' });
    return response;
  }

  async checkInterviewSendableStatus(interviewId, candidates, isSchedule, SentDate, ExpireDate) {
    const requestObject = {
      interviewId,
      candidates,
      isSchedule,
      SentDate,
      ExpireDate,
    };
    const response = await this.Post('interview-sendable-status', requestObject, { root: 'Interview' });
    return response;
  }

  async sendInterviewOk(interviewId, candidates, isSchedule, SentDate, ExpireDate, sendEmail, isScheduleResend) {
    const requestObject = {
      interviewId,
      candidates,
      isSchedule,
      SentDate,
      ExpireDate,
      sendEmail,
      isScheduleResend,
    };
    const response = await this.Post('send-interview', requestObject, { root: 'Interview' });
    return response;
  }

  async getQuestionBanks(pageIndex, pageSize, searchText, languageId) {
    const requestObject = {
      pageIndex,
      pageSize,
      searchText,
      languageId,
    };

    const response = await this.Post('list', requestObject, { root: 'QuestionDef' });
    return response;
  }

  async updateInterviewStatus(interviewId, isActive) {
    const requestObject = {
      interviewId,
      isActive,
    };
    const response = await this.Post(
      'change-isactive',
      requestObject, { root: 'Interview' },
    );
    return response;
  }

  async getCandidates(interviewId, isSuccessful, pageIndex, pageSize) {
    const requestObject = {
      isSuccessful,
      pageIndex,
      pageSize,
    };

    const response = await this.Post(
      `interview/${interviewId}/candidateList`,
      requestObject,
    );
    return response;
  }

  async getInterviewOfCandidate(interviewCandidateLogId, uit) {
    let url = `interview-of-candidate/${interviewCandidateLogId}`;

    if (uit) {
      url = `${url}?uit=${uit}`;
    }

    return this.Get(url, { root: 'Interview' });
  }

  async sendInterview(interviewId, candidateInfo) {
    const requestObject = {
      interviewId,
      candidateInfo,
    };

    const response = await this.Post(
      'Interview/SendInterviewMail',
      requestObject,
    );
    return response;
  }

  async setAnswerRate(interviewCandidateLogId, interviewAnswerId, interviewQuestionId, rate) {
    const requestObject = {
      interviewCandidateLogId,
      interviewAnswerId,
      interviewQuestionId,
      rate,
    };

    const response = await this.Patch('', requestObject, { root: 'interviewCandidate/answer/set-rate' });
    return response;
  }

  async setAnswerNote(interviewCandidateLogId, interviewAnswerId, interviewQuestionId, note) {
    const requestObject = {
      interviewCandidateLogId,
      interviewAnswerId,
      interviewQuestionId,
      note,
    };

    const response = await this.Patch('', requestObject, { root: 'interviewCandidate/answer/set-note' });
    return response;
  }

  async setAnswerLiked(interviewCandidateLogId, interviewAnswerId, interviewQuestionId, isLiked, likeNote) {
    const requestObject = {
      interviewCandidateLogId,
      interviewAnswerId,
      interviewQuestionId,
      isLiked,
      likeNote,
    };

    const response = await this.Patch('', requestObject, { root: 'interviewCandidate/answer/set-liked' });
    return response;
  }

  async setLiked(interviewCandidateLogId, type, isLiked, likeNote) {
    // None = 0,
    // Analyze = 1,
    // Summary = 2,
    const requestObject = {
      id: interviewCandidateLogId,
      type,
      isLiked,
      likeNote,
    };

    const response = await this.Patch('', requestObject, { root: 'interviewCandidateLogAi/set-liked' });
    return response;
  }

  async startAnalyze(analyzeWorkOrderType, doThisAllCandidateInInterview, interviewId, interviewCandidateLogIds, force, language) {
    // None = 0,
    // Transcription = 1,
    // Analyze = 2,
    // Summary = 3,
    const requestObject = {
      analyzeWorkOrderType,
      doThisAllCandidateInInterview,
      interviewId,
      interviewCandidateLogIds,
      force,
      language,
    };

    const response = await this.Post('', requestObject, { root: 'interviewCandidateLogAi/start-analyze' });
    return response;
  }

  async getRights(types) {
    const requestObject = {
      types,
    };

    const response = await this.Post('', requestObject, { root: 'companyRight/rights' });
    return response;
  }

  async getRight(type) {
    // {
    //     None = 0,
    //     AsyncInterview = 1,
    //     User = 2,
    //     InterviewCandidateTranscription = 3,
    //     InterviewCandidateAnlayze = 4,
    //     InterviewCandidateSummary = 5,
    //     GenerateQuestionWithAi = 6, -> AI Question Assistant
    //     SendReport = 7, -> Interview Report
    //     BulkSend = 8 -> candidate ekleme Bulk Sending ( totalRemaining > 0  ise toplu gönderme hakkı var. Gönderim hakkı var ama toplu gönderim hakkı yok. )
    // }
    const response = await this.Get('', { root: `companyRight/${type}` });
    return response;
  }

  async getUserRight() { // user ekleme hakkı için
    const response = await this.Get('', { root: 'CompanyRight/user-right' });
    return response;
  }

  async getCandidateListOfInterview(
    interviewId,
    status,
    pageIndex,
    pageSize,
    searchText,
    sortBy,
    order,
    showMine,
    assignmentUserIds,
    showUnassigned,
  ) {
    const requestObject = {
      interviewId,
      status,
      pageIndex,
      pageSize,
      searchText,
      sortBy,
      order,
      showMine,
      assignmentUserIds,
      showUnassigned,
    };
    const response = await this.Post('interview-candidates-by-interviewId', requestObject, { root: 'Interview' });
    return response;
  }

  async inventoryCompanyNotify(isClosePopupEvent) {
    const requestObject = {
      isClosePopupEvent,
    };

    const response = await this.Post(
      'Inventory/InventoryCompanyNotify',
      requestObject,
    );
    return response;
  }

  async getSendableStatusForCandidates(interviewId, candidateInfo) {
    const requestObject = {
      interviewId,
      candidateInfo,
    };

    const response = await this.Post(
      'Interview/interview-sendable-status',
      requestObject,
    );
    return response;
  }

  async forgotPasswordLinkValidation(
    id,
    uuid,
  ) {
    const requestObject = {
      userId: id,
      guid: uuid,
    };

    const response = await this.Post('forgot-password-link-validation', requestObject, { root: 'Auth' });
    return response;
  }

  async changePassword(
    changePasswordReasonType,
    userId,
    guid,
    currentPassword,
    newPassword,
    confirmNewPassword,
  ) {
    const requestObject = {
      changePasswordReasonType,
      userId,
      guid,
      currentPassword,
      newPassword,
      confirmNewPassword,
    };

    const response = await this.Post('change-password', requestObject, { root: 'Auth' });
    return response;
  }

  async getSampleQuestions(positionId, jobDescription, languageId) {
    const request = {
      positionId,
      jobDescription,
      languageId,
    };

    const response = await this.Post('sample-questions', request, { root: 'AI' });
    return response;
  }

  async getJobPositions(request) {
    const response = await this.Post('list', request, { root: 'Position' });
    return response;
  }

  async getPackages() {
    const response = await this.Get('packages', { root: 'Payment' });
    return response;
  }

  async getSessionId(packageId, paymentProviderTypeId) {
    const response = await this.Post(
      `${paymentProviderTypeId}/${packageId}`,
      null,
      { root: 'Payment/checkout' },
    );
    return response;
  }

  async paymentStart(packageId) {
    const request = {
      packageId,
    };
    const response = await this.Post('start', request, { root: 'Payment' });
    return response;
  }

  async getSettingKey(keyName) {
    const response = await this.Get(`${keyName}`, { root: 'Settings' });
    return response;
  }

  async getCompanyPackage() {
    const response = await this.Get('package', { root: 'Company' });
    return response;
  }

  async getCompanyPackages() {
    const response = await this.Get('packages', { root: 'Company' });
    return response;
  }

  async saveInterviewAnswer(id, interviewCandidateId, answers) {
    const requestObject = {
      id,
      interviewCandidateId,
      answers,
    };
    const response = await this.Post('', requestObject, { root: 'InterviewAnswer' });
    return response;
  }

  async getStripeCustomerPortalUri() {
    const response = await this.Get('stripe-customer-portal-uri', { root: 'Company' });
    return response;
  }

  async downloadInterviewReport(interviewId) {
    const response = await this.Get(`${interviewId}/download-report`, { root: 'Interview' });
    return response;
  }

  async getCompanyTrialPackageInfo() {
    // null -> hiç başlamamış
    // true -> kullanmış, expire olmuş
    // false -> kullanıyor, expire olmamış
    const response = await this.Get('trial-package-info', { root: 'Company' });
    return response;
  }

  async getCandidateIndividualReport(interviewCandidateLogId) {
    const response = await this.Get(`${interviewCandidateLogId}/individual-report`, { root: 'InterviewCandidate' });
    return response;
  }

  async setUserLanguage(languageId) {
    const response = await this.Patch('', {}, { root: `User/set-language/${languageId}` });
    return response;
  }

  // ### Unified ###
  async getUnifiedIntegrations() {
    const response = await this.Get('integrations', { root: 'Unified' });
    return response;
  }

  async createAuthLink(type) {
    const response = await this.Get(`auth/${type}`, { root: 'Unified' });
    return response;
  }

  async setConnectionId(connectionId) {
    const response = await this.Post(`connect/${connectionId}`, {}, { root: 'Unified' });
    return response;
  }

  async disconnectIntegration(integrationType) {
    const response = await this.Delete(`disconnect/${integrationType}`, {}, { root: 'Unified' });
    return response;
  }

  async getUnifiedData(category, type, feature, query) {
    const response = await this.Get(`${category}/${type}/${feature}?${query}`, { root: 'Unified' });
    const data = JSON.parse(response);
    return data;
  }

  async deleteInterviewCandidate(interviewCandidateLogId) {
    const response = await this.Delete(`${interviewCandidateLogId}`, {}, { root: 'InterviewCandidate' });
    return response;
  }

  async updateInterviewName(interviewId, name) {
    const requestObject = {
      name,
    };
    const response = await this.Patch(`${interviewId}/change-name`, requestObject, { root: 'Interview' });
    return response;
  }

  async assignEvaluatorToCandidate(interviewCandidateLogId, assignmentUserIds) {
    const requestObject = {
      interviewCandidateLogId,
      assignmentUserIds,
    };
    const response = await this.Post('assign-to-candidate', requestObject, { root: 'CandidateEvaluatorAssignment' });
    return response;
  }

  async removeEvaluatorFromCandidate(interviewCandidateLogId, assignmentUserId) {
    const requestObject = {
      interviewCandidateLogId,
      assignmentUserId,
    };
    const response = await this.Delete('remove-assign-from-candidate', requestObject, { root: 'CandidateEvaluatorAssignment' });
    return response;
  }

  async getInterviewCandidateEvaluators(interviewCandidateLogIds) {
    const requestObject = {
      interviewCandidateLogIds,
    };
    const response = await this.Post('list-assignments', requestObject, { root: 'CandidateEvaluatorAssignment' });
    return response;
  }

  async getTotalCandidateCount(interviewId) {
    const response = await this.Get(`${interviewId}/total-candidate-count`, { root: 'Interview' });
    return response;
  }

  async bulkAssignEvaluatorToCandidate(interviewId, candidateGroups, candidateFilters) {
    const requestObject = {
      interviewId,
      candidateGroups,
      candidateFilters,
    };
    const response = await this.Post('bulk-assign-to-candidates', requestObject, { root: 'CandidateEvaluatorAssignment' });
    return response;
  }

  async reactivateCandidate(candidateLogId, resetAnswers) {
    const requestObject = {
      resetAnswers,
    };

    const response = await this.Patch('', requestObject, { root: `interviewCandidate/${candidateLogId}/reactivate` });
    return response;
  }

  async resendInterview(candidateLogId) {
    const response = await this.Post('', null, { root: `interviewCandidate/${candidateLogId}/resend` });
    return response;
  }

  async getTotalUnassignedCandidateCount(interviewId) {
    const response = await this.Get(`unassigned-candidate-count/${interviewId}`, { root: 'CandidateEvaluatorAssignment' });
    return response;
  }

  async getTranscriptionResult(interviewCandidateLogId) {
    const response = await this.Get(`${interviewCandidateLogId}/transcriptions`, { root: 'InterviewCandidateLogAi' });
    return response;
  }

  async getAnalyzeResult(interviewCandidateLogId, language) {
    const response = await this.Get(`${interviewCandidateLogId}/analyze-result/${language}`, { root: 'InterviewCandidateLogAi' });
    return response;
  }

  async getSummaryResult(interviewCandidateLogId, language) {
    const response = await this.Get(`${interviewCandidateLogId}/summary/${language}`, { root: 'InterviewCandidateLogAi' });
    return response;
  }

  async getSwitchUserList(searchText, pageIndex, pageSize) {
    const requestObject = {
      searchText,
      pageIndex,
      pageSize,
    };
    const response = await this.Post('switch-user-list', requestObject, { root: 'User' });
    return response;
  }

  async setSwitchUser(applicationType = 1, switchUserId) {
    const requestObject = {
      applicationType,
      switchUserId,
    };

    const response = await this.Post('switch-user', requestObject, { root: 'Auth' });
    return response;
  }

  async getAddOrUpdateCriteriaControl(interviewId) {
    const response = await this.Get(`${interviewId}/add-or-update-criteria-control`, { root: 'Interview' });
    return response;
  }

  async getInterviewCriterias(interviewId, languageId = null) {
    const requestObject = {
      interviewId,
      languageId,
    };
    const response = await this.Post('criterias', requestObject, { root: 'Interview' });
    return response;
  }

  async addOrUpdateInterviewCriteria(interviewId, languageId = null, criterias) {
    const requestObject = {
      interviewId,
      languageId,
      criterias,
    };
    const response = await this.Post('criterias/add-or-update', requestObject, { root: 'Interview' });
    return response;
  }

  async getDefaultCriterias(languageId = null) {
    const requestObject = {
      languageId,
    };
    const response = await this.Post('default-list', requestObject, { root: 'Criteria' });
    return response;
  }

  async getGenerateCriterias(positionId, jobDescription, languageId = null) {
    const requestObject = {
      positionId,
      jobDescription,
      languageId,
    };
    const response = await this.Post('generate', requestObject, { root: 'Criteria' });
    return response;
  }

  async getPositionWithId(positionId) {
    const response = await this.Get(`${positionId}`, { root: 'Position' });
    return response;
  }

  async scheduleAndResendCandidate(interviewId, interviewCandidateLogIds, scheduleAndResendAll, status, isSchedule, sentDate, expireDate, sendEmail) {
    const requestObject = {
      interviewId,
      interviewCandidateLogIds,
      scheduleAndResendAll,
      status,
      isSchedule,
      sentDate,
      expireDate,
      sendEmail,
    };
    const response = await this.Post('schedule-and-resend', requestObject, { root: 'InterviewCandidate' });
    return response;
  }
})();
